import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-charg_mode",
  "use": "icon-charg_mode-usage",
  "viewBox": "0 0 22 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 24\" fill=\"none\" id=\"icon-charg_mode\">\n  <path d=\"M21.8 7.2V22.7918C21.8 23.4601 21.2662 24 20.6079 24H1.39203C0.733891 24 0.199951 23.4672 0.199951 22.8098V1.19016C0.199951 0.546372 0.738391 0 1.4026 0H14.5961L21.8 7.2ZM19.4 8.4H13.4V2.4H2.59995V21.6H19.4V8.4ZM6.19995 6H9.79995V8.4H6.19995V6ZM6.19995 10.8H15.8V13.2H6.19995V10.8ZM6.19995 15.6H15.8V18H6.19995V15.6Z\" fill=\"#FF8993\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol